import React from "react";

export interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const IconAntibody = ({
  width = 24,
  height = 24,
  color = "#515C6C",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        className="modality-icon-fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75814 4.05358C4.9997 3.80701 5.39135 3.80701 5.63292 4.05358L7.33681 5.79276C7.57837 6.03933 7.57837 6.43909 7.33681 6.68566C7.09525 6.93223 6.7036 6.93223 6.46203 6.68566L4.75814 4.94647C4.51657 4.69991 4.51657 4.30014 4.75814 4.05358ZM3.56261 5.39782C3.80417 5.15125 4.19583 5.15125 4.43739 5.39782L6.14128 7.137C6.38285 7.38357 6.38285 7.78333 6.14128 8.0299C5.89972 8.27647 5.50807 8.27647 5.26651 8.0299L3.56261 6.29071C3.32105 6.04415 3.32105 5.64438 3.56261 5.39782ZM11.5364 11.1699C11.5364 10.8248 11.2566 10.5449 10.9114 10.5449C10.5663 10.5449 10.2864 10.8248 10.2864 11.1699V19.5C10.2864 19.8452 10.5663 20.125 10.9114 20.125C11.2566 20.125 11.5364 19.8452 11.5364 19.5V11.1699ZM13.7042 11.1699C13.7042 10.8248 13.4244 10.5449 13.0792 10.5449C12.734 10.5449 12.4542 10.8248 12.4542 11.1699V19.5C12.4542 19.8452 12.734 20.125 13.0792 20.125C13.4244 20.125 13.7042 19.8452 13.7042 19.5V11.1699ZM19.5626 5.39782C19.8042 5.15125 20.1958 5.15125 20.4374 5.39782C20.679 5.64438 20.679 6.04415 20.4374 6.29071L18.7335 8.0299C18.4919 8.27647 18.1003 8.27647 17.8587 8.0299C17.6172 7.78333 17.6172 7.38357 17.8587 7.137L19.5626 5.39782ZM18.3671 4.05358C18.6086 3.80701 19.0003 3.80701 19.2418 4.05358C19.4834 4.30014 19.4834 4.69991 19.2418 4.94647L17.5379 6.68566C17.2964 6.93223 16.9047 6.93223 16.6632 6.68566C16.4216 6.43909 16.4216 6.03933 16.6632 5.79276L18.3671 4.05358ZM6.44631 8.34118C6.68787 8.09461 7.07952 8.09461 7.32109 8.34118L9.02498 10.0804C9.26655 10.3269 9.26655 10.7267 9.02498 10.9733C8.78342 11.2198 8.39177 11.2198 8.1502 10.9733L6.44631 9.23407C6.20475 8.9875 6.20475 8.58774 6.44631 8.34118ZM16.6789 8.34118C16.9204 8.09461 17.3121 8.09461 17.5536 8.34118C17.7952 8.58774 17.7952 8.9875 17.5536 9.23407L15.8497 10.9733C15.6082 11.2198 15.2165 11.2198 14.975 10.9733C14.7334 10.7267 14.7334 10.3269 14.975 10.0804L16.6789 8.34118ZM7.64187 6.99694C7.88343 6.75037 8.27508 6.75037 8.51664 6.99694L10.2205 8.73612C10.4621 8.98269 10.4621 9.38245 10.2205 9.62902C9.97898 9.87559 9.58732 9.87559 9.34576 9.62902L7.64187 7.88983C7.4003 7.64327 7.4003 7.2435 7.64187 6.99694ZM15.4833 6.99694C15.7249 6.75037 16.1165 6.75037 16.3581 6.99694C16.5997 7.2435 16.5997 7.64327 16.3581 7.88983L14.6542 9.62902C14.4126 9.87559 14.021 9.87559 13.7794 9.62902C13.5379 9.38245 13.5379 8.98269 13.7794 8.73612L15.4833 6.99694Z"
        fill={color}
      />
    </svg>
  );
};

IconAntibody.displayName = "Antibody";

export default IconAntibody;
